import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecipesRoutes } from './recipes.routing';
import { SharedModule } from 'src/app/shared/shared.module';
import { RecipesComponent } from './pages/recipes.component';
import { RecipeDetailComponent } from './content/recipe-detail/recipe-detail.component';

@NgModule({
  imports: [
    CommonModule,
    RecipesRoutes,
    SharedModule
  ],
  declarations: [
    RecipesComponent,
    RecipeDetailComponent
  ]
})
export class RecipesModule { }
